import {
  Chain,
  getChainInfoByChainId,
  CHAIN_LOWER_NAME_TO_ID,
} from '@/lib/config/chain';
import { useSelector } from 'react-redux';
import {
  reduxCurrentChainId,
  setCurrentChainId,
} from '@/lib/stores/accountSlice';
import { useDispatch } from 'react-redux';
import { useParams, useSearchParams } from 'next/navigation';
import { useEffect, useCallback } from 'react';

export function useChainInfo() {
  const dispatch = useDispatch();
  const rCurrentChainId = useSelector(reduxCurrentChainId);
  const searchParams = useSearchParams();
  const chainIdFromParams = searchParams.get('chainId');
  const { chain } = useParams<{ chain?: Lowercase<Chain> }>();
  const chainIdFromPath = chain
    ? `${CHAIN_LOWER_NAME_TO_ID[chain]}`
    : undefined;

  const chainId =
    chainIdFromPath ??
    chainIdFromParams ??
    localStorage.getItem('chainId') ??
    rCurrentChainId;

  useEffect(() => {
    const chainIdStorage = localStorage.getItem('chainId');
    if (!chainIdStorage) {
      localStorage.setItem('chainId', chainId);
    }
    dispatch(setCurrentChainId(chainId));
  }, []);

  const chainInfo = getChainInfoByChainId(chainId);

  const updateChainId = useCallback(
    (chainId: string) => {
      localStorage.setItem('chainId', chainId);
      const action = setCurrentChainId(chainId);
      dispatch(action);
    },
    [dispatch],
  );

  return {
    chainInfo,
    chainId: chainId,
    setChainId: updateChainId,
  };
}
